export default __webpack_public_path__ + "static/media/hero1.883cd63e.jpg";